import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M20 4h-3V3c0-.6-.4-1-1-1s-1 .4-1 1v1H9V3c0-.6-.4-1-1-1s-1 .4-1 1v1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 6v1c0 .6.4 1 1 1s1-.4 1-1V6h6v1c0 .6.4 1 1 1s1-.4 1-1V6h3v4H4V6h3zM4 20v-8h16v8H4z" />,
  'Calendar'
)
